import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Button, Row, FormControl, Col, Form } from 'react-bootstrap';
import { Column, Table } from 'react-virtualized';
import DateTimeField from 'react-bootstrap-datetimepicker';
import { Chart } from 'react-google-charts';
import moment from 'moment';

import StatisticsInfo from './StatisticsInfo';
import PieCharts from './PieChart';
import { gettext } from '../../../i18n/service.js';
import * as settingsActions from '../../../actions/settingsActions';
import * as appActions from '../../../actions/appActions';
import LoopbackHttp from '../../../businessLogic/LoopbackHttp.js';
import isEmpty from '../../../businessLogic/isObjectEmpty.js';

class Statistics extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      startDate: parseInt(moment().startOf('day').format('x')),
      endDate: parseInt(moment().endOf('day').format('x')),
      byValue: 'day',
      selectedDriver: -1,
      selectedTeam: -1,
      title: gettext('COMPLETED-ORDERS'),
      name: 'completedOrders'
    }
  }

  componentDidMount() {
    if (LoopbackHttp.isFleet) {
      this.props.settingsActions.getTeamsForFleetSettings(this.props.company.id)
      this.props.settingsActions.getFleetDrivers(this.props.company.id);

    } else if (LoopbackHttp.isOperator) {
      this.props.settingsActions.getTeamsForOperatorSettings(this.props.account.id)
      this.props.settingsActions.getOperatorDrivers(this.props.account.id);
    }
    this.applyFilterByPeriod();
  }

  applyFilterByPeriod() {
    const { startDate, endDate, selectedDriver, selectedTeam } = this.state;
    if (selectedDriver == -1 && selectedTeam == -1) {
      this.props.appActions.startSpinner();
      this.props.settingsActions.clearStatistics();
      let fields = {};
      if (LoopbackHttp.isFleet) {
        fields = {
          period: this.state.byValue,
          companyId: this.props.company.id,
          type: 'Company'
        }
        this.props.settingsActions.companyDriverAnalytics(fields)

      } else if (LoopbackHttp.isOperator) {
        fields = {
          period: this.state.byValue,
          operatorId: this.props.account.id,
          type: 'Operator'
        }
        this.props.settingsActions.operatorTeamsDriversAnalytics(fields)
      }
    } else if (selectedDriver != -1) {
      this.applyFilterbyDriver();
    } else if (selectedTeam != -1 && selectedDriver == -1) {
      this.applyFilterByTeam();
    }
  }

  applyFilterByTeam() {
    this.props.appActions.startSpinner();
    this.props.settingsActions.clearStatistics();
    const { startDate, endDate, selectedTeam } = this.state;
    let fields = {};
    if (selectedTeam == -1) {
      this.props.appActions.startSpinner();
      this.props.settingsActions.clearStatistics();
      
      if (LoopbackHttp.isFleet) {
        fields = {
          period: this.state.byValue,
          companyId: this.props.company.id,
          type: 'Company'
        }
        this.props.settingsActions.companyDriverAnalytics(fields)

      } else if (LoopbackHttp.isOperator) {
        fields = {
          period: this.state.byValue,
          operatorId: this.props.account.id,
          type: 'Operator'
        }
        this.props.settingsActions.operatorTeamsDriversAnalytics(fields)
      }
    } else {
      fields = {
        period: this.state.byValue,
        teamId: selectedTeam,
        type: 'Team'
      }
      this.props.settingsActions.teamDriversAnalytics(fields);
      this.props.settingsActions.getDriverbyTeam(selectedTeam);
    }
  }

  applyFilterbyDriver() {
    this.props.appActions.startSpinner();
    this.props.settingsActions.clearStatistics();
    const { startDate, endDate, selectedDriver } = this.state;
    let fields = {};
    if (selectedDriver == -1) {
      this.props.appActions.startSpinner();
      this.props.settingsActions.clearStatistics();
      
      if (LoopbackHttp.isFleet) {
        fields = {
          period: this.state.byValue,
          companyId: this.props.company.id,
          type: 'Company'
        }
        this.props.settingsActions.companyDriverAnalytics(fields)

      } else if (LoopbackHttp.isOperator) {
        fields = {
          period: this.state.byValue,
          operatorId: this.props.account.id,
          type: 'Operator'
        }
        this.props.settingsActions.operatorTeamsDriversAnalytics(fields)
      }
    } else {
      fields = {
        period: this.state.byValue,
        driverId: selectedDriver,
        type: 'Driver'
      }
      this.props.settingsActions.driverAnalytics(fields);
    }
  }

  renderPeriod() {
    return (
      <Form id='statistics_form'>
        <label>{gettext('ANALYTICS-PERIOD')}</label>
        <FormControl
          componentClass="select"
          name="byValue"
          value={this.state.byValue}
          onChange={(event) => {
            this.setState({ byValue: event.target.value }, () => {
              this.applyFilterByPeriod()
            })
          }}>
          <option value="day">{gettext('BY-DAY')}</option>
          <option value="week">{gettext('THIS-WEEK')}</option>
          <option value="month">{gettext('THIS-MONTH')}</option>
          <option value="year">{gettext('THIS-YEAR')}</option>
          {/*<option value="lastweek" selected={this.state.byValue === "lastweek"}>{gettext('LAST-WEEK')}</option>
            <option value="lastmonth" selected={this.state.byValue === "lastmonth"}>{gettext('LAST-MONTH')}</option>
            <option value="lastyear" selected={this.state.byValue === "lastyear"}>{gettext('LAST-YEAR')}</option>
            <option value="period" selected={this.state.byValue === "period"}>{gettext('BY-PERIOD')}</option>*/}
        </FormControl>
      </Form>
    )
  }

  renderTeams() {
    const { teams } = this.props
    if (teams.length > 0) {
      return (
        <Form id='statistics_form'>
          <label>{gettext('TEAM')}</label>
          <FormControl
            componentClass="select"
            name="selectedTeam"
            onChange={(event) => {
              this.setState({ selectedTeam: event.target.value }, () => {
                this.applyFilterByTeam()
              })
            }}
            value={this.state.selectedTeam}>
            <option value="-1">{gettext('ALL-TEAMS-ANALYTICS')}</option>
            {
              _.map(teams, (team, index) => {
                return (
                  <option value={team.id} key={index}>{team.name}</option>
                )
              })
            }
          </FormControl>
        </Form>
      )
    } else
      return null
  }

  renderDrivers() {
    const { drivers } = this.props
    if (drivers.length > 0) {
      return (
        <Form id='statistics_form'>
          <label>{gettext('DRIVERS')}</label>
          <FormControl
            componentClass="select"
            name="selectedDriver"
            onChange={(event) => {
              this.setState({ selectedDriver: event.target.value }, () => {
                this.applyFilterbyDriver()
              })
            }}
            value={this.state.selectedDriver}>
            <option value="-1">{gettext('ALL-DRIVERS-ANALYTICS')}</option>
            {
              _.map(drivers, (driver, index) => {
                return (
                  <option value={driver.id} key={index}>{driver.firstName}</option>
                )
              })
            }
          </FormControl>
        </Form>
      )
    } else
      return null
  }

  selectOption(title, name) {
    this.setState({ title })
    this.setState({ name })
  }

  showPieCharts() {
    const { statistic } = this.props;
    let totalStatistic = {};

    if (!statistic.length > 0)
      return null;

    statistic.map(item => {
      if (item.title == 'total')
        totalStatistic = item;
      return;
    });
    let complete = [
      ['Delivered Orders', 'Returned Orders'],
      ['delivered', 1],
      ['returned', 1]
    ];
    let earnings = [
      ['driverEarnings', 'totalOrders'],
      ['driverEarnings', 1],
      ['totalOrders', 1]
    ];
    let cash = [
      ['cashInHand', 'cashReturnedToHub'],
      ['cashInHand', 1],
      ['cashReturnedToHub', 1]
    ];
    let orders = [
      ['Orders Accepted', 'Orders Declined'],
      ['accepted', 1],
      ['declined', 1]
    ];
    let punctuality = [
      ['Picked Up In Time', 'Not Picked Up In Time'],
      ['pick', 1],
      ['delivered', 1]
    ];

    let dPunctuality = [
      ['Delivered Up In Time', 'Not Delivered In Time'],
      ['pick', 1],
      ['delivered', 1]
    ];

    if (!_.isEmpty(totalStatistic)) {
      if (totalStatistic.deliveredReturnedRatios.totalDelivered != 0 || totalStatistic.deliveredReturnedRatios.totalReturned != 0)
        complete = [
          ['Delivered Orders', 'Returned Orders'],
          ['delivered', totalStatistic.deliveredReturnedRatios.totalDelivered],
          ['returned', totalStatistic.deliveredReturnedRatios.totalReturned]
        ];

      if (totalStatistic.driverEarnings != 0 && totalStatistic.totalOrders != 0)
        earnings = [
          ['driverEarnings', 'totalOrders'],
          ['driverEarnings', totalStatistic.driverEarnings],
          ['totalOrders', totalStatistic.totalOrders]
        ];

      if (totalStatistic.pickUpTimeAccuracy.pickedUpInTime != 0 || totalStatistic.pickUpTimeAccuracy.notPickedUpInTime != 0)
        punctuality = [
          ['Picked Up In Time', 'Delivered In Time'],
          ['pick', totalStatistic.pickUpTimeAccuracy.pickedUpInTime],
          ['delivered', totalStatistic.pickUpTimeAccuracy.notPickedUpInTime]
        ];

      if (totalStatistic.deliveryTimeRatios.deliveredInTime != 0 || totalStatistic.deliveryTimeRatios.notDeliveredInTime != 0)
        dPunctuality = [
          ['Picked Up In Time', 'Delivered In Time'],
          ['pick', totalStatistic.deliveryTimeRatios.deliveredInTime],
          ['delivered', totalStatistic.deliveryTimeRatios.notDeliveredInTime]
        ];

      if (totalStatistic.cashOnDelivery.cashInHand != 0 || totalStatistic.cashOnDelivery.cashReturnedToHub != 0) {
        cash = [
          ['cashInHand', 'cashReturnedToHub'],
          ['cashInHand', totalStatistic.cashOnDelivery.cashInHand],
          ['cashReturnedToHub', totalStatistic.cashOnDelivery.cashReturnedToHub]
        ];
      }

      if (totalStatistic.orderAcceptance.acceptedOrdersAmount != 0 || totalStatistic.orderAcceptance.declinedOrdersAmount != 0)
        orders = [
          ['Orders Accepted', 'Orders Declined'],
          ['accepted', totalStatistic.orderAcceptance.acceptedOrdersAmount],
          ['declined', totalStatistic.orderAcceptance.declinedOrdersAmount]
        ];

      return (
        <Row className="left-chart">
          <PieCharts
            title={gettext('COMPLETED-ORDERS')}
            tooltip={gettext('TOOLTIP-COMPLETE-ORDERS')}
            commmentOne={gettext('COMPLETED-ORDERS-COMMENTONE')}
            commmentTwo={gettext('COMPLETED-ORDERS-COMMENTTWO')}
            valueOne={totalStatistic.deliveredReturnedRatios.totalDelivered}
            valueTwo={totalStatistic.deliveredReturnedRatios.totalReturned}
            percentOne={totalStatistic.deliveredReturnedRatios.ratioDelivered}
            percentTwo={totalStatistic.deliveredReturnedRatios.ratioReturned}
            data={complete}
            id="CompletePieChart"
            name="completedOrders"
            selectOption={this.selectOption.bind(this)}
            isSelected={this.state.name == 'completedOrders'? true : false}
          />
          <PieCharts
            title={gettext('CASH-OND-DELIVERY')}
            tooltip={gettext('TOOLTIP-CASH-ON-DELIVERY')}
            commmentOne={gettext('CASH-OND-DELIVERY-COMMENTONE')}
            commmentTwo={gettext('CASH-OND-DELIVERY-COMMENTTWO')}
            valueOne={totalStatistic.cashOnDelivery.cashReturnedToHub}
            valueTwo={totalStatistic.cashOnDelivery.cashInHand}
            percentOne={totalStatistic.cashOnDelivery.cashReturnedPercent}
            percentTwo={totalStatistic.cashOnDelivery.cashInHandPercent}
            data={cash}
            id="CashPieChart"
            name="cashonDelivery"
            selectOption={this.selectOption.bind(this)}
            isSelected={this.state.name == 'cashonDelivery'? true : false}
          />
          <PieCharts
            title={gettext('ACCEPTANCE-RATE')}
            tooltip={gettext('TOOLTIP-ACCEPTANCE-RATE')}
            commmentOne={gettext('ACCEPTANCE-RATE-COMMENTONE')}
            commmentTwo={gettext('ACCEPTANCE-RATE-COMMENTTWO')}
            valueOne={totalStatistic.orderAcceptance.acceptedOrdersAmount}
            valueTwo={totalStatistic.orderAcceptance.declinedOrdersAmount}
            percentOne={totalStatistic.orderAcceptance.acceptedOrdersPercent}
            percentTwo={totalStatistic.orderAcceptance.declinedOrdersPercent}
            data={orders}
            id="OrderPieChart"
            name="acceptanceRate"
            isSelected={this.state.name == 'acceptanceRate'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
          <PieCharts
            title={gettext('PICKUP-PUNCTUALITY')}
            tooltip={gettext('TOOLTIP-PICKUP-PUNCTUALITY')}
            commmentOne={gettext('PICKUP-PUNCTUALITY-COMMENTONE')}
            commmentTwo={gettext('PICKUP-PUNCTUALITY-COMMENTTWO')}
            valueOne={totalStatistic.pickUpTimeAccuracy.pickedUpInTime}
            valueTwo={totalStatistic.pickUpTimeAccuracy.notPickedUpInTime}
            percentOne={totalStatistic.pickUpTimeAccuracy.pickUpInTimePercent}
            percentTwo={totalStatistic.pickUpTimeAccuracy.notPickUpInTimePercent}
            data={punctuality}
            id="PunPieChart"
            name="pickupPunctuality"
            isSelected={this.state.name == 'pickupPunctuality'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
          <PieCharts
            title={gettext('DELIVERY-PUNCTUALITY')}
            tooltip={gettext('TOOLTIP-DELIVERY-PUNCTUALITY')}
            commmentOne={gettext('DELIVERY-PUNCTUALITY-COMMENTONE')}
            commmentTwo={gettext('DELIVERY-PUNCTUALITY-COMMENTTWO')}
            valueOne={totalStatistic.deliveryTimeRatios.deliveredInTime}
            valueTwo={totalStatistic.deliveryTimeRatios.notDeliveredInTime}
            percentOne={totalStatistic.deliveryTimeRatios.ratioDeliveredInTime}
            percentTwo={totalStatistic.deliveryTimeRatios.ratioNotDeliveredInTime}
            data={dPunctuality}
            id="DPunPieChart"
            name="deliveryPunctuality"
            isSelected={this.state.name == 'deliveryPunctuality'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
        </Row>
      );
    } else {
      return (
        <Row className="left-chart">
          <PieCharts
            title={gettext('COMPLETED-ORDERS')}
            tooltip={gettext('TOOLTIP-COMPLETE-ORDERS')}
            commmentOne={gettext('COMPLETED-ORDERS-COMMENTONE')}
            commmentTwo={gettext('COMPLETED-ORDERS-COMMENTTWO')}
            valueOne="0"
            valueTwo="0"
            percentOne="0"
            percentTwo="0"
            data={complete}
            id="CompletePieChart"
            name="completedOrders"
            selectOption={this.selectOption.bind(this)}
            isSelected={this.state.name == 'completedOrders'? true : false}
          />
          <PieCharts
            title={gettext('CASH-OND-DELIVERY')}
            tooltip={gettext('TOOLTIP-CASH-ON-DELIVERY')}
            commmentOne={gettext('CASH-OND-DELIVERY-COMMENTONE')}
            commmentTwo={gettext('CASH-OND-DELIVERY-COMMENTTWO')}
            valueOne="0"
            valueTwo="0"
            percentOne="0"
            percentTwo="0"
            data={cash}
            id="CashPieChart"
            name="cashonDelivery"
            isSelected={this.state.name == 'cashonDelivery'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
          <PieCharts
            title={gettext('ACCEPTANCE-RATE')}
            tooltip={gettext('TOOLTIP-ACCEPTANCE-RATE')}
            commmentOne={gettext('ACCEPTANCE-RATE-COMMENTONE')}
            commmentTwo={gettext('ACCEPTANCE-RATE-COMMENTTWO')}
            valueOne="0"
            valueTwo="0"
            percentOne="0"
            percentTwo="0"
            data={orders}
            id="OrderPieChart"
            name="acceptanceRate"
            isSelected={this.state.name == 'acceptanceRate'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
          <PieCharts
            title={gettext('PICKUP-PUNCTUALITY')}
            tooltip={gettext('TOOLTIP-PICKUP-PUNCTUALITY')}
            commmentOne={gettext('PICKUP-PUNCTUALITY-COMMENTONE')}
            commmentTwo={gettext('PICKUP-PUNCTUALITY-COMMENTTWO')}
            valueOne="0"
            valueTwo="0"
            percentOne="0"
            percentTwo="0"
            data={punctuality}
            id="PunPieChart"
            name="pickupPunctuality"
            isSelected={this.state.name == 'pickupPunctuality'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
          <PieCharts
            title={gettext('DELIVERY-PUNCTUALITY')}
            tooltip={gettext('TOOLTIP-DELIVERY-PUNCTUALITY')}
            commmentOne={gettext('DELIVERY-PUNCTUALITY-COMMENTONE')}
            commmentTwo={gettext('DELIVERY-PUNCTUALITY-COMMENTTWO')}
            valueOne="0"
            valueTwo="0"
            percentOne="0"
            percentTwo="0"
            data={dPunctuality}
            id="DPunPieChart"
            name="deliveryPunctuality"
            isSelected={this.state.name == 'deliveryPunctuality'? true : false}
            selectOption={this.selectOption.bind(this)}
          />
        </Row>
      );
    }
  }

  onListRowClick = (e) => {
    this.props.settingsActions.clearStatistics();
    if (this.state.selectedUser !== e.rowData)
      this.setState({ selectedUser: e.rowData })
    else this.setState({ selectedUser: undefined });

    const fields = {
      start: this.state.startDate,
      end: this.state.endDate,
      period: this.state.byValue,
      userType: e.rowData.role.charAt(0).toUpperCase() + e.rowData.role.slice(1),
      userId: e.rowData.id
    }
    this.props.settingsActions.getlStatistics(fields, 'forUser');
  }

  render() {
    const { drivers, teams, statistic } = this.props

    if (statistic.length > 0) {
      this.props.appActions.endSpinner();
      return (
        <Row className="center_flex statistics_profile">
          <Col sm={12} md={4} className="left-chart-wrap">
            {this.renderPeriod()}
            {this.renderTeams()}
            {this.renderDrivers()}
            {this.showPieCharts()}
          </Col>
          <Col sm={12} md={8} className="right-chart">
            <StatisticsInfo
              statistic={statistic}
              title={this.state.title}
              id={this.state.name} />
          </Col>
        </Row>
      );
    } else {
      return null
    }
  }
}

Statistics.propTypes = {

};

function mapStateToProps(state) {
  return {
    dispatchers: state.settingsPageReducer.dispatchers,
    drivers: state.settingsPageReducer.drivers,
    company: state.appReducer.company,
    account: state.appReducer.account,
    statistic: state.settingsPageReducer.statistic,
    teams: state.settingsPageReducer.teams,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(appActions, dispatch),
    settingsActions: bindActionCreators(settingsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Statistics);



// WEBPACK FOOTER //
// ./src/components/settings/components/Statistics.js